import React, { useState, useEffect, useRef } from "react";
import TwoButton from "../../TwoButton";
import PoolTvlParticipants from "../PoolTvlParticipants";
import { Middle, Reward, BtnWrapper } from "./style";
import { useSelector } from "react-redux";
import "./style.css";
import InputRange from "../../InputRange";
import { getChainDataByChainId } from "../../../utils";

function CardMiddle({ onStake, onUnstake }) {
  const { currentChainId } = useSelector(
    (state) => state.global
  );
  const [disable, setDisable] = useState(true);
  const [currentNetwork, setNetwork] = useState("Not Connected");
  const { poolTknSymbol, rewardTknSymbol } = useSelector(
    (state) => state.global.tknSymbol
  );
  const { poolTokenContract } =
    useSelector((state) => state.global.poolContracts);
  const { endBlock, currentBlockNO } = useSelector(
    (state) => state.global.poolDetailsFromFactory
  );
  const {
    RewardDiff,
    reward,
    rewardDistributed,
    totalStake,
  } = useSelector(
    (state) => state.global.actionBasedData
  )

  const { isLogin } = useSelector((state) => state.login);
  const [activeDeactive, setActiveDeactive] = useState(true);

  const totalStakeMethod = async () => {
    if (isLogin) {
      let chainData = getChainDataByChainId(currentChainId)
      setNetwork(chainData?.chainName || "Wrong Network")
      if (totalStake <= 0 && reward <= 0) {
        setDisable(true);
      } else {
        setDisable(false);
      }
    } else {
      setNetwork("Not Connected");
      setDisable(true);
    }
  };

  useEffect(() => {
    if(currentChainId && poolTokenContract) {
      totalStakeMethod();
    }
  }, [isLogin, currentChainId, poolTokenContract]);

  useEffect(() => {
    if(currentBlockNO && endBlock) {
      if(Number(currentBlockNO) > Number(endBlock)) {
        setActiveDeactive(true)
      } else {
        setActiveDeactive(false)
      }
    }
  }, [currentBlockNO, endBlock]);

  return (
    <Middle>
      <p>Chain connected: {currentNetwork}</p>
      <PoolTvlParticipants
        large={true}
        label1="Your Stake"
        value1={
          totalStake && poolTknSymbol
            ? totalStake + " " + poolTknSymbol
            : poolTknSymbol === undefined
              ? "0"
              : 0 + " " + poolTknSymbol
        }
        lable2="Earned Reward"
        value2={
          reward && rewardTknSymbol
            ? reward + " " + rewardTknSymbol
            : rewardTknSymbol === undefined
              ? "0"
              : 0 + " " + rewardTknSymbol
        }
      />

      <Reward>
        <p>Reward Distributed</p>
        <InputRange value={RewardDiff} max={rewardDistributed} />
        <div className="flex">
          <p>
            {RewardDiff && rewardDistributed
              ? ((RewardDiff / rewardDistributed) * 100).toFixed(2) + "%"
              : 0 + "%"}
          </p>
          <p>
            {rewardDistributed
              ? RewardDiff?.toFixed(2) + "/" + rewardDistributed + " "
              : "0 / 0"}
          </p>
        </div>
      </Reward>

      <BtnWrapper>
        <TwoButton
          current="stake"
          modal={false}
          buttons={[
            {
              name: "Stake",
              onClick: () => onStake && onStake(),
              identifier: "stake",
              disabled: activeDeactive,
              disableHelper: "End Block Reached",
            },
            {
              name: "UnStake",
              onClick: () => onUnstake && onUnstake(),
              identifier: "unstake",
              disabled: disable,
              // style: { backgroundColor: theme.palette.common.background },
              disableHelper: "button disabled",
            },
          ]}
          space
        />
      </BtnWrapper>
    </Middle>
  );
}

export default CardMiddle;
